import React from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { Navigate, useLocation } from "react-router-dom";
import Loading from "../../components/Loading/Loading";
import auth from "../Firebase/firebase.init";

type Props = {
  children: any;
};

const RequireAuth = ({ children }: Props) => {
  const [user, loading] = useAuthState(auth);
  const location = useLocation();

  if (loading) {
    return <Loading />;
  }

  if (!user) {
    return <Navigate to="/getStarted" state={{ from: location }} replace></Navigate>;
  }
  return children;
};

export default RequireAuth;
